export const LoaderSimple = () => {
  return (
    <svg data-testid='loader' viewBox='0 0 78 78' className='stroke-current w-full h-full'>
      <g fill='none' color='currentColor' className='animate-loader1 origin-center'>
        <circle cx='39' cy='39' r='39' stroke='currentColor' />
        <circle cx='39' cy='39' r='39' stroke='currentColor' />
      </g>
      <g fill='none' color='currentColor' className='animate-loader2 origin-center'>
        <circle cx='39' cy='39' r='39' stroke='currentColor' />
        <circle cx='39' cy='39' r='39' stroke='currentColor' />
      </g>
      <g fill='none' color='currentColor' className='animate-loader3 origin-center'>
        <circle cx='39' cy='39' r='39' stroke='currentColor' />
        <circle cx='39' cy='39' r='39' stroke='currentColor' />
      </g>
    </svg>
  );
};
